module.exports = __webpack_public_path__ + "img/AccountingDonutRejected.86a42307.png";